module.exports = __webpack_public_path__ + "img/service3.8d11ca02.png";